import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";

import TxtBox from "../../Custom/TxtBox";
import UiDialog from "../../../components/Custom/UiDialog";
import RadioBtn from "../../../components/Custom/RadioBtn";
import Btn from "../../../components/Custom/Btn";
import SwitchBtn from "../../../components/Custom/SwitchBtn";
import AutoComplete from "../../../components/Custom/AutoComplete";
import Loader from "../../../components/Custom/Loader";
import ExcelGrid from "../../../components/Custom/ExcelGrid";

import { CONFIG, NOTIFY } from "../../../common/config";
import { COLORS } from "../../../common/colors";
import { DEFAULTS } from "../../../common/config";
import {
  LABELS,
  WARNINGS,
  TITLES,
  SUCCESS,
  ERRORS,
} from "../../../common/lables";
import { COMMON_JS } from "../../../common/scripts";
import TxtRow from "../../../components/Custom/TxtRow";

import { PRODUCT_APIs } from "../../../apihandlers/product";
import { AUTH_APIs } from "apihandlers/auth";

const SubCategory = (props: any) => {
  const { setDashMenu } = props;

  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [rows, setRows] = useState<any>(null);
  const [countries, setCounteries] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [products, setProducts] = useState<any>(null);
  const [grams, setGrams] = useState<any>(null);
  const [taxes, setTaxes] = useState<any>(null);
  const [uploadFiles, setUploadFiles] = useState<any>([]);
  const [fileId, setFileId] = useState<any>();

  const productRef: any = useRef(null);

  const gramsRef: any = useRef(null);
  const taxRef: any = useRef(null);

  useEffect(() => {
    if (loading) {
      getProducts();
    }
  }, [loading]);

  const getProducts = () => {
    const args = {
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
      activeStatus: true,
    };
    PRODUCT_APIs.getProducts(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.productName,
          };
        });
        setProducts(list);
        getGrams();
      }
    });
  };
  const getGrams = () => {
    const args = {
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
      activeStatus: true,
    };
    PRODUCT_APIs.getGramsMaster(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.name,
          };
        });
        setGrams(list);
        getTax();
      }
    });
  };
  const getTax = () => {
    const args = {
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
      activeStatus: true,
    };
    PRODUCT_APIs.getTaxMaster(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.taxName,
          };
        });
        setTaxes(list);
        getRows();
      }
    });
  };
  const getRows = async () => {
    try {
      const args = {
        pageNo: 1,
        pageLength: DEFAULTS.PAGE_LENGTH,
        searchQry: "",
        driverCode: false,
      };
      const res: any = await PRODUCT_APIs.getProductSubCategory(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < response.records.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatusText"] = "Yes";
          } else {
            list[i]["activeStatusText"] = "No";
          }
        }
        setRows(list);
        setLoading(false);

        console.log("Rows List :", list);
      }
    } catch (error) {
      console.error("getCurrencies:", error);
    }
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
    console.log(selectedRow);
  };
  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
  };

  const COLUMNS = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      align: "center",
      headerAlign: "center",
    },
    {
      key: "name",
      name: LABELS.SUB_CATEGORY_NAME,
      width: "45%",
    },

    {
      key: "activeStatusText",
      name: LABELS.ACTIVE,
      width: "45%",
    },

    {
      key: "options",
      name: "Options",
      width: "5%",
      renderCell: (params) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onEditRow(params.row)}
            >
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];
  const onUploadFile = (e: any, f: any) => {
    console.log("onUploadFile: ", e, f);
    const file: any = e.target.files[0];
    if (file.size / 1024 / 1024 > CONFIG.MAX_FILE_SIZE) {
      COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.FILE_SIZE_EXCEEDED);
      return;
    }
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      let base64: any = reader.result;
      setUploadFiles(null);
      uploadFile(file, base64).then((res) => {
        console.log("uploadFile:", res);
        setUploadFiles([res]);
        //manageFiles();
      });
    };
    reader.onerror = (error) => {
      console.log("uploadFile: Error:", error);
    };
  };

  const uploadFile = async (file: any, base64 = "") => {
    const args = {
      recordRefId: 1,
      file: {
        name: file.name,
        data: base64.replace("data:", "").replace(/^.+,/, ""),
        type: file.type,
        mimeType: file.name.split(".")[1],
        size: file.size,
      },
      category: "crm",
    };
    let fileInfo = null;
    try {
      const res = await AUTH_APIs.fileUpload(args);
      console.log("uploadFile: ", args, res);
      const response: any = res.response;
      if (res.status === 200) {
        fileInfo = response;
        setFileId(fileInfo.id);

        // manageleaddocument
      }
    } catch (error) {}
    return fileInfo;
  };

  const manageSubCategory = () => {
    const subCategory = (
      document.getElementById("subCategory") as HTMLInputElement
    ).value.trim();

    let op = document.querySelector(
      'input[name="activeStatus"]:checked'
    ) as HTMLInputElement;
    const activeStatus = op ? op.value : "";
    // Validations
    // if (!productId) {
    //   COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.PLEASE_FILL_MANDATORY_FIELDS);
    //   return;
    // }
    // if (!productName) {
    //   COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.PLEASE_FILL_MANDATORY_FIELDS);
    //   return;
    // }

    // if (!aliasName) {
    //   COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.PLEASE_FILL_MANDATORY_FIELDS);
    //   return;
    // }

    // if (!gramsId) {
    //   COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.PLEASE_FILL_MANDATORY_FIELDS);
    //   return;
    // }
    // if (!taxStructureId) {
    //   COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.PLEASE_FILL_MANDATORY_FIELDS);
    //   return;
    // }
    // if (!price) {
    //   COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.PLEASE_FILL_MANDATORY_FIELDS);
    //   return;
    // }
    // if (!mrp) {
    //   COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.PLEASE_FILL_MANDATORY_FIELDS);
    //   return;
    // }
    // if (!sortingOrder) {
    //   COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.PLEASE_FILL_MANDATORY_FIELDS);
    //   return;
    // }

    const args = {
      id: selectedRow.id || -1,
      name: subCategory,
      aliasName: subCategory,
      activeStatus,
      imageId: fileId,
      sortOrder: 1,
      orgId: 1,
    };
    console.log("args", args);
    setIsSubmit(true);
    PRODUCT_APIs.manageProductSubCategory(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);

        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  console.log("selectedRow", selectedRow);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.MASTERS} </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.SUB_CATEGORY}</li>
        </ul>
        <h4>{TITLES.SUB_CATEGORY}</h4>
        {/* <p>{SUB_TITLES.CURRENCY}</p> */}
      </div>

      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            height={window.innerHeight * 0.8}
            cols={COLUMNS}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={LABELS.SUB_CATEGORY}
            onReload={reloadGrid}
            onAdd={onAdd}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " + LABELS.SUB_CATEGORY + ": " + selectedRow.productName
              : "Add New " + LABELS.SUB_CATEGORY
          }
          open={true}
          size={"sm"}
          onClose={() => {
            setManageDialog(false);
          }}
        >
          <div className="formGroup">
            <TxtRow
              id={"subCategory"}
              type={"text"}
              label={LABELS.SUB_CATEGORY}
              required={true}
              defaultValue={selectedRow.name}
              disabled={isSubmit}
            />
          </div>

          <div className="formGroup">
            <label>{LABELS.STATUS}</label>
            <RadioBtn
              list={[
                {
                  id: "true",
                  value: "true",
                  label: LABELS.ACTIVE,
                  checked: selectedRow.id
                    ? selectedRow.activeStatus === true
                    : true,
                  disabled: false,
                },
                {
                  id: "false",
                  value: "false",
                  label: LABELS.INACTIVE,
                  checked: selectedRow.id
                    ? selectedRow.activeStatus === false
                    : false,
                  disabled: false,
                },
              ]}
              row={true}
              name={"activeStatus"}
              disabled={isSubmit}
            />
          </div>

          <div className="formGroup">
            <label>{LABELS.UPLOAD_PHOTO}</label>
            <TxtBox
              type={"file"}
              id="uploadFile"
              // defaultValue={selectedRow.id ? selectedRow.fuelFiles : null}
              //className="uploadFile"
              accept="image/*,.pdf"
              onChange={onUploadFile}
            />
          </div>

          <div className="formGroup submitBtnWrapper">
            <div className="width45 flexRowJustify">
              <Btn
                text={LABELS.SAVE}
                loading={isSubmit}
                onClick={manageSubCategory}
              />
              <Btn
                text={LABELS.CANCEL}
                loading={isSubmit}
                bgColor={COLORS.DIM_DARK_GRAY}
                onClick={() => setManageDialog(false)}
              />
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(SubCategory);
